<app-range-table-data *ngIf="rangeConfig" [payload]="rangeConfig"></app-range-table-data>